// Give the callback exclusive access to the response before MSAL initializes.
const hash = new URLSearchParams(window.location.hash.slice(1));
const query = new URLSearchParams(window.location.search);
const isAuthResponse = [hash, query].some(params =>
  params.has('state') && (params.has('code') || params.has('error')),
);
if (isAuthResponse) {
  document.getElementById('root')!.textContent = 'Завершуємо вхід через Microsoft…';
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch(() => {
      history.replaceState(null, '', window.location.pathname);
      document.getElementById('root')!.textContent =
        'Не вдалося передати результат входу. Закрийте це вікно й повторіть вхід з основної сторінки.';
    });
} else {
  void import('./renderApp');
}
export {};
